import Vue from 'vue'
import Router from 'vue-router'

import { i18n } from './plugins/i18n'

import Start from './views/Start'
import Char1 from './views/Char1'
import Char2 from './views/Char2'
import Char3 from './views/Char3'
import Char4 from './views/Char4'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Start
    },
    {
      path: '/nelitza',
      name: 'char1',
      component: Char1
    },
    {
      path: '/david',
      name: 'char2',
      component: Char2
    },
    {
      path: '/maria-teresa',
      name: 'char3',
      component: Char3
    },
    {
      path: '/jose-luis',
      name: 'char4',
      component: Char4
    }
  ]
})
